<app-manageusers-internal
  [isManageProfile]="true"
  [userId]="userId$ | async"
></app-manageusers-internal>
